import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Merchandise from './pages/Merchandise';
import MerchDetails from './pages/MerchDetails';
import Checkout from './pages/Checkout';
import AppDetails from './pages/AppDetails';
import Booking from './pages/Booking';
import Dashboard from './pages/Dashboard';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import Messaging from './pages/Messaging';
import SearchResults from './pages/SearchResults';
import Events from './pages/Events';
import { AuthProvider } from './context/AuthContext';
import './styles/variables.css';

import Categories from './pages/Categories';
import Contact from './pages/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shopping" element={<Merchandise />} />
              <Route path="/shopping/:id" element={<MerchDetails />} />
              <Route path="/checkout/:id" element={<Checkout />} />
              <Route path="/app/:id" element={<AppDetails />} />
              <Route path="/book/:id" element={<Booking />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/login" element={<Login />} />
              <Route path="/messaging" element={<Messaging />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/events" element={<Events />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
